import React, { useState, useCallback } from 'react';
import Cards from 'react-credit-cards';
import type { Focused } from 'react-credit-cards';

import 'react-credit-cards/es/styles-compiled.css';
import { Col, Row } from 'antd';

import { useFormikContext, Field } from 'formik';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { ICard } from './index';

const NewCard = () => {
  const [currentField, setCurrentField] = useState<Focused>('number');

  const { values, handleBlur } = useFormikContext<ICard>();

  const onFocus = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    const field = e.target.name as Focused;
    setCurrentField(field);
  }, []);

  const onBlurCvc = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      setCurrentField('name');
      handleBlur(e);
    },
    [handleBlur]
  );

  return (
    <Row gutter={[16, 32]} align='middle'>
      <Col xs={24} md={12} className='flex justify-center'>
        <Cards
          focused={currentField}
          cvc={values.cvc}
          expiry={values.expiry}
          name={values.name}
          number={values.number}
          locale={{ valid: 'Validade' }}
          placeholders={{ name: 'SEU NOME AQUI' }}
        />
      </Col>
      <Col xs={24} md={12}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Field
              id='card-number-input'
              name='number'
              component={TextFormField}
              fullWidth
              label='Número do cartão'
              placeholder='Insira o número do cartão'
              mask='creditcard'
              onFocus={onFocus}
            />
          </Col>
          <Col span={24}>
            <Field
              id='card-name-input'
              name='name'
              component={TextFormField}
              fullWidth
              label='Nome impresso no cartão'
              placeholder='Insira o nome igual do cartão'
              onFocus={onFocus}
              mask={'onlylettersandspace'}
              maxLength={50}
            />
          </Col>
          <Col xs={24} md={12}>
            <Field
              id='card-expiration-date-input'
              name='expiry'
              component={TextFormField}
              fullWidth
              label='Data de expiração'
              placeholder='MM/AA'
              onFocus={onFocus}
              inputMode='numeric'
              mask={'expirydate'}
            />
          </Col>
          <Col xs={24} md={12}>
            <Field
              id='card-cvv-input'
              name='cvc'
              component={TextFormField}
              fullWidth
              label='Código de segurança'
              placeholder='Insira o CVV do cartão'
              onFocus={onFocus}
              onBlur={onBlurCvc}
              maxLength={4}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default NewCard;
